// extracted by mini-css-extract-plugin
export default {"legacy-iframe-container":"legacy-iframe_legacy-iframe-container__GaDD2","full-height":"legacy-iframe_full-height__JiZTC","legacy-iframe":"legacy-iframe_legacy-iframe__SuXoc"};